const inputCls = "mt-2 w-full rounded-xl border border-white/10 bg-[#0A0A0A] px-4 py-3.5 text-base text-white placeholder:text-zinc-500 outline-none transition-[border-color,box-shadow] duration-300 focus:border-brand-400 focus:shadow-[0_0_0_4px_rgba(186,186,186,0.18)]";

export const Field = ({ label, id, as = "input", options = [], className = "", ...rest }) => (
  <label htmlFor={id} className={`block ${className}`}>
    <span className="text-sm font-medium text-zinc-200">{label}</span>
    {as === "select" ? (
      <select id={id} data-testid={`provider-${id}-select`} className={inputCls} {...rest}>
        {options.map((o) => <option key={o} value={o}>{o || "Select…"}</option>)}
      </select>
    ) : as === "textarea" ? (
      <textarea id={id} rows={4} maxLength={2000} data-testid={`provider-${id}-input`} className={`${inputCls} resize-none`} {...rest} />
    ) : (
      <input id={id} data-testid={`provider-${id}-input`} className={inputCls} {...rest} />
    )}
  </label>
);

export const Chips = ({ label, name, options, selected, onToggle, single = false }) => (
  <fieldset className="sm:col-span-2">
    <legend className="text-sm font-medium text-zinc-200">{label}</legend>
    <div className="mt-3 flex flex-wrap gap-2">
      {options.map((o) => {
        const [value, text] = Array.isArray(o) ? o : [o, o];
        const on = selected.includes(value);
        const slug = value.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        return (
          <button
            type="button"
            key={value}
            role={single ? "radio" : "checkbox"}
            aria-checked={on}
            onClick={() => onToggle(value)}
            data-testid={`provider-${name}-chip-${slug}`}
            className={`rounded-full border px-4 py-2 text-sm transition-[background-color,border-color,color,transform] duration-300 active:scale-95 ${on ? "border-brand-400 bg-brand-400 font-semibold text-[#0A0A0A]" : "border-white/15 text-zinc-200 hover:border-brand-400/60"}`}
          >
            {text}
          </button>
        );
      })}
    </div>
  </fieldset>
);
